/* eslint-disable */
import * as THREE from 'three';
import multiplyMatrixAndPoint from './multiplyMatrixAndPoint';
import rotateMatrix from './rotateMatrix';

export const getRatio = ({ x: w, y: h }, { width, height }, r = 0) => {
	width = 1186;
	height = 1709;
	const m = multiplyMatrixAndPoint(rotateMatrix(THREE.Math.degToRad(r)), [w, h]);
	const originalRatio = {
		w: m[0] / width,
		h: m[1] / height,
	};
	const coverRatio = 1 / Math.max(originalRatio.w, originalRatio.h);
	console.log(
		'x:', w,
		'y:', h,
		'r:', r,
		'm:', m,
		'width:', width,
		'height:', height,
		'originalRatio:', originalRatio,
		'coverRatio:', coverRatio
	);
	return new THREE.Vector2(
		originalRatio.w * coverRatio,
		originalRatio.h * coverRatio,
	);
};

export default getRatio;
